module.exports = __webpack_public_path__ + "img/yellow-lily.de2fdfd2.webp";